function emitClarityEvent(name) {
  if (typeof window === 'undefined' || typeof window.clarity !== 'function') return false;
  try {
    window.clarity('event', name);
    return true;
  } catch (error) {
    return false;
  }
}

function trackQualityResult(result) {
  emitClarityEvent('ai_quality_photo_analyzed');
  if (result.faceAnalysis?.status === 'unavailable') emitClarityEvent('ai_quality_face_unavailable');
  if (result.faceAnalysis?.closedEyeFaces > 0) emitClarityEvent('ai_quality_closed_eye_detected');
  if (result.sharpness?.isBlurry) emitClarityEvent('ai_quality_blur_detected');
  if (result.exposure?.issue) emitClarityEvent('ai_quality_exposure_detected');
}

function trackQualityFailure() {
  emitClarityEvent('ai_quality_analysis_failed');
}

function trackOrderScanStarted() {
  emitClarityEvent('ai_quality_order_scan_started');
}

function trackOrderScanCompleted() {
  emitClarityEvent('ai_quality_order_scan_completed');
}

function trackDuplicateDetected() {
  emitClarityEvent('ai_quality_duplicate_detected');
}

function trackQualityFilterViewed(filter) {
  const supported = new Set(['review', 'closed', 'blur', 'exposure', 'duplicate']);
  if (supported.has(filter)) emitClarityEvent(`ai_quality_${filter}_filter_opened`);
}

function trackQualityDeletion(results) {
  const deletedResults = results || [];
  if (deletedResults.some(result => result.faceAnalysis?.closedEyeFaces > 0)) {
    emitClarityEvent('ai_quality_closed_eye_photo_deleted');
  }
  if (deletedResults.some(result => result.sharpness?.isBlurry)) {
    emitClarityEvent('ai_quality_blur_photo_deleted');
  }
  if (deletedResults.some(result => result.exposure?.issue)) {
    emitClarityEvent('ai_quality_exposure_photo_deleted');
  }
}

export {
  emitClarityEvent,
  trackDuplicateDetected,
  trackQualityDeletion,
  trackQualityFailure,
  trackQualityFilterViewed,
  trackQualityResult,
  trackOrderScanCompleted,
  trackOrderScanStarted,
};
